import { memo } from "react";

import SingleLegalDocument from "./SingleLegalDocument";

function PrivacyPolicy() {
   return <SingleLegalDocument document="privacyPolicy" />;
}

export default memo(PrivacyPolicy);
